module.exports = __webpack_public_path__ + "static/media/happiness.72cd8d0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happiness.svg
// module id = 485
// module chunks = 0